import { Modal } from "antd";

/**
 * 打开发送授权链接聊天对话框的弹框
 */
export function openSendAuthUrlModal(oauthUrl: string, nick: string) {
    Modal.confirm({
        title: "是否向需要授权的店铺主账号发送授权链接?",
        content: <p className="error">授权后需要刷新页面更新授权状态</p>,
        onOk() {
            // @ts-ignore
            my.qn.openChat({
                text: `${oauthUrl}`,
                nick: `cntaobao${nick}`,
            });
        },
    });
}
